export const serviceAreas = [
  {
    slug: 'laurel',
    name: 'Laurel',
    countyLabel: 'Home Base',
    county: "Prince George's County",
    subhead: "Pronto Notary is based right here in Laurel. As our home base, we're often able to offer same-day appointments.",
    detail: 'This is where Carlos lives and works day to day.'
  },
  {
    slug: 'beltsville',
    name: 'Beltsville',
    countyLabel: 'PG County',
    county: "Prince George's County",
    subhead: 'Convenient mobile and online notary appointments are available in Beltsville, including same-day scheduling when available.',
    detail: ''
  },
  {
    slug: 'college-park',
    name: 'College Park',
    countyLabel: 'PG County',
    county: "Prince George's County",
    subhead: 'Serving the University of Maryland community with convenient mobile and online appointments. Affidavits and parental consent forms come up often near a college town.',
    detail: 'We also work with Portuguese-speaking families in the area.'
  },
  {
    slug: 'greenbelt',
    name: 'Greenbelt',
    countyLabel: 'PG County',
    county: "Prince George's County",
    subhead: 'Greenbelt is one of our regularly served communities, with convenient mobile and online notary appointments available in the evenings and on weekends.',
    detail: ''
  },
  {
    slug: 'silver-spring',
    name: 'Silver Spring',
    countyLabel: 'Montgomery County',
    county: 'Montgomery County',
    subhead: 'Silver Spring is one of the larger communities in our service area. Book a convenient mobile or online appointment for evenings, weekends, and more.',
    detail: ''
  },
  {
    slug: 'aspen-hill',
    name: 'Aspen Hill',
    countyLabel: 'Montgomery County',
    county: 'Montgomery County',
    subhead: 'Enjoy convenient mobile and online notary appointments in Aspen Hill, with availability in the evenings and on weekends.',
    detail: '',
    portuguese: {
      eyebrow: 'PARA A COMUNIDADE BRASILEIRA EM ASPEN HILL',
      heading: "Aspen Hill's Brazilian community, served in Português.",
      body: 'Aspen Hill is home to one of the largest Brazilian communities in Maryland. We handle powers of attorney, apostilles for documents heading to Brazil, and everyday notarizations, explained clearly in Portuguese from start to finish.'
    }
  },
  {
    slug: 'rockville',
    name: 'Rockville',
    countyLabel: 'Montgomery County',
    county: 'Montgomery County',
    subhead: 'Rockville families can book convenient mobile or online notary appointments with evening and weekend availability.',
    detail: '',
    portuguese: {
      eyebrow: 'PARA A COMUNIDADE BRASILEIRA EM ROCKVILLE',
      heading: "Serving Rockville's Brazilian families in Português.",
      body: "Rockville has a strong and growing Brazilian community. Whether it's a procuração for property back home or paperwork for a family member, we walk you through it in your language."
    }
  },
  {
    slug: 'gaithersburg',
    name: 'Gaithersburg',
    countyLabel: 'Montgomery County',
    county: 'Montgomery County',
    subhead: 'Gaithersburg residents can schedule convenient mobile or online notary appointments, including evenings and weekends.',
    detail: '',
    portuguese: {
      eyebrow: 'PARA A COMUNIDADE BRASILEIRA EM GAITHERSBURG',
      heading: "Gaithersburg's Brazilian community, in Português.",
      body: 'Gaithersburg is one of the fastest-growing Brazilian communities in the DMV. We offer apostille services for documents heading to Brazil and general notarizations explained clearly in Portuguese.'
    }
  }
];

export const serviceLinks = [
  { label: 'Mobile Notary', href: '/services/mobile-notary' },
  { label: 'Remote Online Notary', href: '/services/remote-online-notary' },
  { label: 'Apostille', href: '/services/apostille' },
  { label: 'General Notarizations', href: '/services/general-notarizations' },
  { label: 'I-9 Employment Verification', href: '/services/i-9-employment-verification' },
  { label: 'Business & Corporate', href: '/services/business-corporate' },
  { label: 'Medical & Healthcare', href: '/services/medical-healthcare' },
  { label: 'Family & Estate Planning', href: '/services/family-estate-planning' },
  { label: 'Vehicle Documents', href: '/services/vehicle-documents' }
];